import { useEffect } from "react";
import { areSwitchesBootstrapped } from "../api/bootstrapApi";
import { plannerCockpitApi } from "../api/plannerCockpitApi";
import { viperRebalanceApi } from "../api/viperRebalanceApi";
import { setFeatureSwitch, useFeatureSwitchesVersion } from "./featureSwitches";

// Release 1.6.0: the menu entries for VIPER Rebalance and the Planner Cockpit stay hidden until their governed switches
// are on (the server answers 404 while off and is the authority). Checked after sign-in and every ten minutes.

export const VIPER_REBALANCE_FEATURE = "planning.viper_rebalance";
export const PLANNER_COCKPIT_FEATURE = "planning.cockpit";
const RECHECK_MS = 10 * 60_000;

function statusOf(error: unknown): number | undefined {
  return (error as { response?: { status?: number } } | null)?.response?.status;
}

export async function refreshRelease160Switches(): Promise<void> {
  await Promise.all([
    viperRebalanceApi
      .status()
      .then((s) => setFeatureSwitch(VIPER_REBALANCE_FEATURE, s.enabled === true))
      .catch((e: unknown) => {
        if (statusOf(e) === 404) setFeatureSwitch(VIPER_REBALANCE_FEATURE, false);
      }),
    plannerCockpitApi
      .getCount()
      .then(() => setFeatureSwitch(PLANNER_COCKPIT_FEATURE, true))
      .catch((e: unknown) => {
        if (statusOf(e) === 404) setFeatureSwitch(PLANNER_COCKPIT_FEATURE, false);
      })
  ]);
}

/** Loads both switches while someone with a role is signed in, and re-renders the caller (the shell) when they change. */
export function useRelease160Switches(signedIn: boolean): void {
  useFeatureSwitchesVersion();
  useEffect(() => {
    if (!signedIn) return undefined;
    if (!areSwitchesBootstrapped()) {
      void refreshRelease160Switches();
    }
    const timer = window.setInterval(() => void refreshRelease160Switches(), RECHECK_MS);
    return () => window.clearInterval(timer);
  }, [signedIn]);
}
